import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate,useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { JWT_VAl } from "./Functions/jwt_validate";
import Header from "../Component/Header";
import { createCookie, deleteCookie, getCookie } from "../CookieFunctions";
import { apihost, authhost,basehost } from "../ApiHost";

const ConfirmModal = ({ isOpen, onClose, onConfirm, ideaId }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-md p-6 rounded-lg shadow-lg text-center">
        <h2 className="text-xl font-semibold text-gray-800">Confirm Deletion</h2>
        <p className="mt-4 text-gray-600">
          Are you sure you want to delete this idea?
        </p>
        <div className="mt-6 flex justify-center space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 rounded-md text-gray-800 hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(ideaId)}
            className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

const Home = () => {
  const [dropdownIndex, setDropdownIndex] = useState(null);
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedIdeaId, setSelectedIdeaId] = useState(null);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const [Loading, setLoading] = useState(true);
  const location = useLocation(); // Get the location object
  const queryParams = new URLSearchParams(location.search)

  useEffect(() => {
    const fetchData = async () => {
      if (queryParams.get("idea")) {
        navigate(`/validator/?idea=${queryParams.get("idea")}`);
        return;
      }
      try {
      const JWT = await JWT_VAl();
      if (!JWT.success && !JWT.verified) {
        createCookie("loginRedirect",basehost+'/home' );
        window.location.href= authhost;
      }
      if (JWT.success && !JWT.verified) {
        createCookie("loginRedirect",basehost+'/home' );
        window.location.href= authhost+'/verify';
      }
      }catch (error) {
        console.error("Error fetching data:", error);
        createCookie("loginRedirect",basehost+'/home' );
        window.location.href= authhost;
      }
      try {
        const response = await fetch(`${apihost}/validate/getAll`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("_JWT")}`,
          },
        });
        const result = await response.json();
        setData(result.Ideas || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [navigate]);

  const toggleDropdown = (event, index) => {
    event.stopPropagation();
    setDropdownIndex(dropdownIndex === index ? null : index);
  };

  const openModal = (id) => {
    setSelectedIdeaId(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedIdeaId(null);
  };

  const handleDelete = async (id) => {
    try {
      const response = await fetch(`${apihost}/validate/delete/${id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("_JWT")}`,
        },
      });
      console.log(response);
      if (response.ok) {
        setData(data.filter((idea) => idea.Id !== id));
        // alert("Idea deleted successfully.");
      } else {
        alert("Failed to delete the idea. Please try again.");
      }
    } catch (error) {
      console.error("Error deleting idea:", error);
      alert("An error occurred. Please try again.");
    } finally {
      closeModal();
    }
  };
  if (Loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Loading...
      </div>
    );
  }
  return (
    <div className="min-h-screen bg-[rgb(245_243_255)]">
      <Helmet>
        <title>InsightNest | Home</title>
        <meta name="description" content="Validate your ideas with InsightNest" />
        <meta name="keywords" content="Home, InsightNest, Ideas, Idea Validation" />
      </Helmet>
      <Header />
      <div className="mt-20 space-y-4 pb-32">
        {data.length === 0 ? (
          <h2 className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-4xl font-bold text-gray-600 text-center">
            No Ideas to Validate Yet
          </h2>
        ) : (
          data.map(({ Id, title }, index) => (
            <div
              key={Id}
              className="relative flex items-center justify-between bg-white border border-gray-300 rounded-lg p-4 max-w-md mx-auto shadow-sm hover:shadow-md transition"
            >
              <Link to={`/view/${Id}`} className="flex-grow truncate">
                <p className="text-gray-800 font-medium truncate">{title}</p>
              </Link>
              <div ref={dropdownRef} className="relative">
                <button
                  onClick={(event) => toggleDropdown(event, index)}
                  className="focus:outline-none"
                >
                  <img
                    src="https://cdn.jsdelivr.net/npm/bootstrap-icons/icons/three-dots.svg"
                    alt="Menu"
                    className="w-6 h-6 text-gray-500 hover:text-gray-700"
                  />
                </button>
                {dropdownIndex === index && (
                  <div
                    className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded-lg shadow-lg z-10"
                    onClick={(event) => event.stopPropagation()}
                  >
                    <button
                      onClick={() => openModal(Id)}
                      className="block px-4 py-2 w-full text-left text-gray-700 hover:bg-[rgb(100_65_233)] hover:text-white text-sm"
                    >
                      Delete
                    </button>
                    <button className="block px-4 py-2 w-full text-left text-gray-700 hover:bg-[rgb(100_65_233)] hover:text-white text-sm">
                      Share
                    </button>
                    <Link
                      to={`/view/${Id}`}
                      className="block px-4 py-2 text-left text-gray-700 hover:bg-[rgb(100_65_233)] hover:text-white text-sm"
                    >
                      View
                    </Link>
                  </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>
      <div className="fixed bottom-0 left-0 w-full bg-white py-6 border-t border-gray-300 z-20">
        <Link to={"/validator"}>
          <button className="bg-[rgb(100_65_233)] text-white font-semibold w-3/4 max-w-md mx-auto py-3 block rounded-lg hover:bg-[rgb(85_50_210)] transition">
            Validate New Idea
          </button>
        </Link>
      </div>

      <ConfirmModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onConfirm={handleDelete}
        ideaId={selectedIdeaId}
      />
    </div>
  );
};

export default Home;
